<template>
  <page-view title="添加出库专家">
    <template slot="action">
      <a-button type="primary" :loading="saveLoading" @click="onSubmit">保存</a-button>
    </template>
    <a-card>
      <a-form-model
          :model="outExpertForm"
          ref="outExpertForm"
          class="exi_form item_100"
          :label-col="{ flex: '0 0 auto' }"
          :wrapper-col="{ span: 24 }"
      >
        <template v-if="formType!=='ExpertOut'">
          <a-button type="primary" icon="plus" @click="openStockOut" ghost>选择出库专家</a-button>
          <a-row type="flex" align="middle" :gutter="20" v-for="(item,index) in outExpertForm.data" :key="index">
            <a-col :span="3">
              <a-form-model-item label="专家名称"
                                 :rules="{required: true, message: '请选专家名称', trigger: 'change'}"
                                 :prop="'data.'+index+'.expertName'">
                <a-input placeholder="专家名称" readOnly
                         v-model="item.expertName"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item label="出库日期"
                                 :rules="{required: true, message: '请选择出库日期', trigger: 'change'}"
                                 :prop="'data.'+index+'.stockOutDate'">
                <a-date-picker placeholder="出库日期"
                               format="YYYY-MM-DD"
                               v-model="item.stockOutDate"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="出库原因" prop="stockOutReason">
                <a-textarea v-model="item.stockOutReason" rows="1"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="5">
              <a-form-model-item label="上传文件">
                <upload-selector :referId='item.id' configKey='expert.stockout.att'/>
              </a-form-model-item>

            </a-col>
            <a-popconfirm title="删除前请手动删掉附件（如有），是否删除？" @confirm="delOutExpert(item.id)">
              <a-button type="danger">
                移除
              </a-button>
            </a-popconfirm>
          </a-row>
        </template>
        <template v-else v-for="(item,index) in outExpertForm.data">
          <a-row :key="index" :gutter="20">
            <a-col :span="4">
              <a-form-model-item label="专家名称"
                                 :rules="{required: true, message: '专家名称', trigger: 'change'}"
                                 :prop="'data.'+index+'.expertName'">
                <a-input placeholder="专家名称" :disabled="true"
                         v-model="item.expertName"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item label="出库日期"
                                 :rules="{required: true, message: '请选择出库日期', trigger: 'change'}"
                                 :prop="'data.'+index+'.stockOutDate'">
                <a-date-picker placeholder="出库日期"
                               format="YYYY-MM-DD"
                               v-model="item.stockOutDate"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="7">
              <a-form-model-item label="出库原因" prop="stockOutReason">
                <a-textarea v-model="item.stockOutReason" rows="2"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <upload-selector :referId='item.id' configKey='expert.stockout.att'/>
            </a-col>
          </a-row>
        </template>
      </a-form-model>
    </a-card>
    <select-expert-modal ref="selectExpertRef" :visible="selectExpertVisible" @success="afterSelectExpertSuccess"
                         @cancel="selectExpertVisible=false"/>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import UploadSelector from '@/components/selector/UploadSelector'
import SelectExpertModal from '@/epp/expertmain/expertInfo/common/SelectExpertModal'
import ChoosePurchaseItem from '@/epp/expertmain/purchaseitems/ChoosePurchaseItem.vue'
import moment from 'moment'
import { SetExpertStockOut } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'expertStockOutForm',
  components: {
    ChoosePurchaseItem,
    PageView,
    UploadSelector,
    SelectExpertModal
  },
  watch: {},
  props:{
    formType:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      saveLoading: false,
      outExpertForm: {
        data: []
      },
      selectExpertVisible: false,
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    //打开出库专家列表
    openStockOut () {
      this.selectExpertVisible = true
      this.$refs.selectExpertRef.preView([...this.outExpertForm.data])
    },
    //从专家那边过来
    fromLoginExpert (expert) {
      expert.stockOutDate = expert.stockOutDate ? moment(expert.stockOutDate) : moment()
      this.outExpertForm.data.push(expert)
    },
    //获取选择的专家列表
    afterSelectExpertSuccess (data) {
      let newOutExpertForm = []
      data.forEach(item => {
        const newData = this.outExpertForm.data.filter(item2 => item.id === item2.id)[0]
        if (newData) {
          newOutExpertForm.push(newData)
        } else {
          newOutExpertForm.push(item)
        }
      })
      newOutExpertForm.map(item => item.stockOutDate = item.stockOutDate ? moment(item.stockOutDate) : moment())
      this.outExpertForm.data = [...newOutExpertForm]
      this.selectExpertVisible = false
    },
    //删除出库专家
    delOutExpert (id) {
      let newData = this.outExpertForm.data.filter(item => item.id !== id)
      this.outExpertForm.data = [...newData]
    },
    //提交出库数据
    onSubmit () {
      this.$refs.outExpertForm.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          this.saveLoading = true
          const data = { expertStockOutVoList: [...this.outExpertForm.data] }
          data.expertStockOutVoList.map(item => item.stockOutDate = item.stockOutDate && item.stockOutDate.format('YYYY-MM-DD'))
          console.log(data)
          let res = await SetExpertStockOut(data)
          if (200 !== res.code) {
            this.$message.error('提交出库审核失败')
            return
          }
          this.$message.success('提交出库审核成功')
          await this.$router.push({ path: `/expertInfo/expertStockOut` })
        } catch (e) {
          this.$message.error(e.message)
        } finally {
          this.saveLoading = false
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
